<div [formGroup]="formGroup()" class="flex flex-col w-full" *transloco="let t">
  <mat-form-field [appearance]="appearance()" class="fuse-mat-dense flex-auto" (click)="triggerClickEvent()">
    @if (label() && !hiddenLabel()) {
      <mat-label>
        {{ (translate() ? t(label()) : label()) | capitalize }}
      </mat-label>
    }

    <input
      matInput
      [hmaxFloat]="isFloat()"
      [decimalQty]="decimalQty()"
      [emitEvent]="emitEvent()"
      [allowNegative]="allowNegative()"
      [class]="classInput()"
      [ngClass]="{ 'arrow-hide': isFloat() }"
      type="number"
      [min]="allowNegative() && min() === undefined ? null : !allowNegative() && min() === undefined ? 0 : min()"
      [max]="max()"
      [step]="step() ? step() : 1"
      inputmode="step() !== 1 ? 'decimal': 'numeric'"
      [name]="controlName()"
      [placeholder]="placeholder()"
      [readonly]="readonly()"
      [formControlName]="resolvedControlName()"
      [autocomplete]="autocomplete()"
      (keydown)="handleKeyDown($event)"
      (blur)="triggerBlurEvent()"
    />

    @if (icon()) {
      <mat-icon matSuffix ngClass="{{ 'icon-size-' + iconSize() }}" svgIcon="{{ icon() }}"></mat-icon>
    } @else if (iconText()) {
      <span matSuffix class="mr-2 font-bold">{{ iconText() }}</span>
    }

    @if (validateField.hasErrorValidate(formControl, 'required')) {
      <mat-error>{{ t('required-field') }}</mat-error>
    } @else if (validateField.hasErrorValidate(formControl, 'min')) {
      <mat-error>
        {{ t('minimum') | titlecase }}
        {{ validateField.validateLength(formControl, 'min') }}
      </mat-error>
    } @else if (validateField.hasErrorValidate(formControl, 'max')) {
      <mat-error>
        {{ t('maximum') | titlecase }}
        {{ validateField.validateLength(formControl, 'max') }}
      </mat-error>
    } @else if (validateField.hasErrorValidate(formControl, 'notLessThan')) {
      <mat-error>
        {{ t('minimum') | titlecase }}
        {{ validateField.validateLength(formControl, 'notLessThan') }}
      </mat-error>
    } @else if (validateField.hasErrorValidate(formControl, 'notGreaterThan')) {
      <mat-error>
        {{ t('maximum') | titlecase }}
        {{ validateField.validateLength(formControl, 'notGreaterThan') }}
      </mat-error>
    }
  </mat-form-field>
</div>
